import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index'
import Upload from '@/pages/upload'
import Suc from '@/pages/suc'
import Interest from '@/pages/interest'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
    },
    {
      path: '/upload',
      name: 'upload',
      component: Upload,
    },
    {
      path: '/suc',
      name: 'suc',
      component: Suc,
    },
    {
      path: '/interest',
      name: 'interest',
      component: Interest,
    }
  ]
})
 


// WEBPACK FOOTER //
// ./src/router/index.js